// extracted by mini-css-extract-plugin
export default {"container":"kV7XjWc6f+iL0Pn9yqEe1Q==","content":"f0+S+libkA5w1Wgckobc4w=="};